<ngb-alert
  [type]="'success'"
  *ngIf="statusMessage && !statusMessage.includes('sentimos')"
>
  {{ statusMessage }}
</ngb-alert>
<ngb-alert
  [type]="'danger'"
  *ngIf="statusMessage && statusMessage.includes('sentimos')"
>
  {{ statusMessage }}
</ngb-alert>

<app-spinner *ngIf="isLoading"></app-spinner>

<div class="card" *ngIf="!isLoading">
  <div class="card-header">
    Listado de platos

    <form class="form-inline float-right d-none d-md-flex">
      <div class="row">
        <label>Desde:</label>
        <div class="form-group hidden">
          <div class="input-group">
            <input
              name="datepicker"
              class="form-control"
              ngbDatepicker
              #datepicker="ngbDatepicker"
              [autoClose]="'outside'"
              (dateSelect)="onDateSelection($event, true)"
              [displayMonths]="2"
              [dayTemplate]="t"
              outsideDays="hidden"
              [startDate]="fromDate!"
              tabindex="-1"
            />
            <ng-template #t let-date let-focused="focused">
              <span
                class="custom-day"
                [class.focused]="focused"
                [class.range]="isRange(date)"
                [class.faded]="isHovered(date) || isInside(date)"
                (mouseenter)="hoveredDate = date"
                (mouseleave)="hoveredDate = null"
              >
                {{ date.day }}
              </span>
            </ng-template>
          </div>
        </div>
        <div class="form-group">
          <div class="input-group">
            <input
              #dpFromDate
              class="form-control input-calendar"
              placeholder="yyyy-mm-dd"
              name="dpFromDate"
              (click)="datepicker.toggle()"
              [value]="formatter.format(fromDate)"
              (input)="fromDate = validateInput(fromDate, dpFromDate.value)"
            />
            <div class="input-group-append">
              <button
                class="btn btn-outline-secondary fa fa-calendar"
                (click)="datepicker.toggle()"
                type="button"
              ></button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <label>Hasta:</label>
        <div class="form-group">
          <div class="input-group">
            <input
              #dpToDate
              class="form-control input-calendar"
              placeholder="yyyy-mm-dd"
              name="dpToDate"
              (click)="datepicker.toggle()"
              [value]="formatter.format(toDate)"
              (input)="toDate = validateInput(toDate, dpToDate.value)"
            />
            <div class="input-group-append">
              <button
                class="btn btn-outline-secondary fa fa-calendar"
                (click)="datepicker.toggle()"
                type="button"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="card-body table-card-body">
    <div class="d-block d-md-none pt-1 pb-2 text-center overflow-auto">
      <ngb-datepicker
        #dp
        (dateSelect)="onDateSelection($event, true)"
        [displayMonths]="2"
        [dayTemplate]="t"
        outsideDays="hidden"
      >
      </ngb-datepicker>

      <ng-template #t let-date let-focused="focused">
        <span
          class="custom-day"
          [class.focused]="focused"
          [class.range]="isRange(date)"
          [class.faded]="isHovered(date) || isInside(date)"
          (mouseenter)="hoveredDate = date"
          (mouseleave)="hoveredDate = null"
        >
          {{ date.day }}
        </span>
      </ng-template>
    </div>

    <div *ngIf="!platosLength" class="text-center pt-3 pb-3">
      <h3>No se han encontrado resultados entre las fechas seleccionadas</h3>
      <h4 class="text-muted">Por favor, seleccione otra fecha</h4>
    </div>

    <div class="float-left">
      <div class="form-group">
        <input
          class="form-control"
          placeholder="Buscar en una fecha concreta"
          name="dp"
          ngbDatepicker
          #d="ngbDatepicker"
          style="display: none"
          (dateSelect)="onDateSelection($event, false)"
        />
        <button
          class="btn btn-light btn-icon"
          (click)="d.toggle()"
          type="button"
        >
          Buscar en una fecha concreta<i class="fa fa-search"></i>
        </button>
      </div>

      <div class="form-group">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Buscar en descripción"
            [(ngModel)]="keyword"
            (keyup.enter)="onKeywordSearch()"
            autofocus
          />
          <div class="input-group-append">
            <button
              class="btn btn-secondary"
              type="submit"
              (click)="onKeywordSearch()"
            >
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="form-group">
        <button
          class="btn btn-light btn-icon btn-erase"
          (click)="resetFilters()"
          type="button"
        >
          Borrar filtros<i class="fa fa-eraser"></i>
        </button>
      </div>
    </div>

    <p *ngIf="platosLength" class="text-muted float-right">
      <strong>{{ platosLength }} plato(s)</strong> en el intervalo seleccionado.
    </p>
    <div *ngIf="platosLength" class="table-responsive">
      <table class="table table-striped">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Imagen</th>
            <th scope="col">Fecha</th>
            <th scope="col">Horario</th>
            <th scope="col">Descripción</th>
            <th scope="col">Creado por</th>
            <th scope="col">Modificado por</th>
            <th scope="col" style="min-width: 175px">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let plato of platos">
            <td
              *ngIf="plato.image_path"
              [routerLink]="['/platos/editar', plato.url_slug]"
            >
              <img
                src="{{
                  imageBaseURL +
                    plato.image_path.replace('/images/', '/images/xs-')
                }}"
              />
            </td>
            <td *ngIf="!plato.image_path"></td>
            <td [routerLink]="['/platos/editar', plato.url_slug]">
              {{ plato.plato_date.substr(0, 10) }}
            </td>
            <td
              [routerLink]="['/platos/editar', plato.url_slug]"
              class="horario horario-{{ plato.horario_id }}"
            >
              {{ plato.horario_description }}
            </td>
            <td
              class="text-muted plato-description"
              [routerLink]="['/platos/editar', plato.url_slug]"
            >
              {{ plato.plato_description }}
            </td>
            <td
              class="text-muted"
              [routerLink]="['/platos/editar', plato.url_slug]"
            >
              {{ plato.created_by }}
              <span class="text-muted"
                >({{
                  plato.date_created.substr(0, 16).replace("T", "&nbsp;&nbsp;")
                }})</span
              >
            </td>
            <td
              class="text-muted"
              [routerLink]="['/platos/editar', plato.url_slug]"
            >
              {{ plato.modified_by }}
              <span class="text-muted"
                >({{
                  plato.date_last_modified
                    .substr(0, 16)
                    .replace("T", "&nbsp;&nbsp;")
                }})</span
              >
            </td>
            <!--<td>
        {{
          user.date_privacy_accepted.substr(0, 16).replace('T', '&nbsp;&nbsp;')
        }}
      </td>
      <td *ngIf="user.date_last_login">
        {{ user.date_last_login.substr(0, 16).replace('T', '&nbsp;&nbsp;') }}
      </td>
      <td *ngIf="!user.date_last_login">- Nunca -</td>
      <td>{{ user.role_description }}</td>-->
            <td>
              <a
                class="btn btn-sm btn-primary btn-editar"
                [routerLink]="['/platos/editar', plato.url_slug]"
              >
                <i class="fa fa-pencil" aria-hidden="true"></i
                >&nbsp;&nbsp;Editar
              </a>
              <a
                *ngIf="plato.url_slug"
                class="btn btn-sm btn-primary btn-previsualizar"
                target="_blank"
                href="https://app.cookadhoc.com/tabs/platos/{{
                  plato.url_slug
                }}"
              >
                <i class="fa fa-eye" aria-hidden="true"></i>&nbsp;&nbsp;Ver en
                la APP
              </a>
              <a
                class="btn btn-sm btn-primary btn-redes"
                (click)="onOpenModal(contentRedes, plato)"
              >
                <i class="fa fa-share" aria-hidden="true"></i>&nbsp;&nbsp;Redes
                sociales
              </a>
              <!--&nbsp;<button
          type="button"
          class="btn btn-sm btn-danger"
          (click)="
            onDelete(
              user.user_id,
              user.role_description,
              user.firstname,
              user.surname,
              user.email
            )
          "
        >
          Eliminar
        </button>-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ngb-pagination
  *ngIf="platosLength > pageSize && !isLoading"
  class="d-flex justify-content-center"
  [(page)]="currentPage"
  (pageChange)="onPageChange($event)"
  [pageSize]="pageSize"
  [collectionSize]="platosLength"
  [boundaryLinks]="false"
  [maxSize]="5"
  [rotate]="true"
></ngb-pagination>

<!-- Modal para compartir en redes sociales -->
<ng-template #contentRedes let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Redes sociales</h4>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- Toast de confirmación -->
    <div
      *ngIf="showToast"
      class="toast-container position-fixed"
      style="z-index: 1050"
    >
      <ngb-toast [autohide]="true" [delay]="3000" (hidden)="showToast = false">
        Contenido copiado al portapapeles. Ya puede usar PEGAR o CTRL + V.
      </ngb-toast>
    </div>

    <div class="redes">
      <!-- Botón de Facebook -->
      <a
        [href]="
          'https://www.facebook.com/sharer/sharer.php?u=' +
          'https://app.cookadhoc.com/tabs/platos/' +
          selectedPlato.url_slug
        "
        target="_blank"
        class="btn btn-sm btn-facebook"
      >
        <i class="fa fa-facebook-f"></i> Compartir en Facebook
      </a>

      <!-- Botón de WhatsApp -->
      <a
        [href]="
          'https://api.whatsapp.com/send?text=' +
          encodeUrl(selectedPlatoPlainText) +
          'https://app.cookadhoc.com/tabs/platos/' +
          selectedPlato.url_slug
        "
        target="_blank"
        class="btn btn-sm btn-whatsapp"
      >
        <i class="fa fa-whatsapp"></i> Compartir en Whatsapp
      </a>

      <!-- Botón de Telegram -->
      <a
        [href]="
          'https://t.me/share/url?url=' +
          'https://app.cookadhoc.com/tabs/platos/' +
          selectedPlato.url_slug +
          '&text=' +
          encodeUrl(selectedPlatoPlainText)
        "
        target="_blank"
        class="btn btn-sm btn-telegram"
      >
        <img src="../../../assets/img/telegram.png" alt="Telegram" /> Compartir
        en Telegram
      </a>
    </div>

    <p style="margin-top: 4px">
      <strong>URL del plato:</strong>
    </p>
    <input
      class="form-control"
      [value]="
        'https://app.cookadhoc.com/tabs/platos/' + selectedPlato.url_slug
      "
      readonly
      (click)="copyToClipboard($event)"
    />
    <div class="text-muted text-center" style="margin-top: 3px">
      <small>
        <i class="fa fa-clipboard"></i>&nbsp;&nbsp;Clic en el texto para
        copiarlo al portapapeles.
      </small>
    </div>

    <br />
    <br />
    <p><strong>Compartir en Instagram:</strong></p>
    <textarea
      class="form-control"
      #textarea
      readonly
      [(ngModel)]="selectedPlatoInstagramText"
      (input)="autoResize(textarea)"
      (click)="copyToClipboard($event)"
      rows="12"
    ></textarea>
    <div class="text-muted text-center" style="margin-top: 3px">
      <small>
        <i class="fa fa-clipboard"></i>&nbsp;&nbsp;Clic en el texto para
        copiarlo al portapapeles.
      </small>
    </div>

    <br />
    <div class="text-center">
      <div
        *ngIf="platoImages.length > 0"
        class="d-flex flex-wrap justify-content-center"
      >
        <div *ngFor="let img of platoImages" class="m-2">
          <a
            [href]="'https://assets.cookadhoc.com' + img.imageDownload"
            download
          >
            <img
              [src]="
                'https://assets.cookadhoc.com' +
                img.imageUrl.replace('/images/', '/images/xs-')
              "
              alt="Imagen del plato"
              class="img-thumbnail"
              width="100px"
            />
          </a>
        </div>
      </div>

      <div class="text-muted" *ngIf="platoImages.length === 1">
        <small>
          <i class="fa fa-download"></i>&nbsp;&nbsp;Clic en la imagen para
          descargarla.
        </small>
      </div>

      <div class="text-muted" *ngIf="platoImages.length > 1">
        <small>
          <i class="fa fa-download"></i>&nbsp;&nbsp;Clic en cada imagen para
          descargarla.
        </small>
      </div>
    </div>
    <br />
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.close('Close click')">
      Cerrar
    </button>
  </div>
</ng-template>
